import React from 'react';
import './WhyCommunity.css';
import Frame244 from './Frame244.png';
import { StyledEngineProvider } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";

const WhyCommunity = () => {
  return (
    <StyledEngineProvider injectFirst>
      <React.Fragment>
        <CssBaseline />
        <div className="why-community" style={{ backgroundColor: '#FFFFFF', '--community-bg-image': `url(${Frame244})` }}>
          <div className="content-wrapper">
            <div className="text-section">
              <h1 className="section-title">Why Join a Community?</h1>
              <p className="section-description">
                Being part of a community on JoyNet means more than just belonging. It's about growing together, sharing your journey, and finding strength in numbers.
              </p>

              <div className="features-list">
                <div className="feature-item">
                  <div className="feature-header">
                    <h3 className="feature-title">Find Support</h3>
                  </div>
                  <p className="feature-description">
                    Connect with others who understand your experiences and can offer empathy and encouragement.
                  </p>
                </div>

                <div className="feature-item">
                  <div className="feature-header">
                    <h3 className="feature-title">Share Experiences</h3>
                  </div>
                  <p className="feature-description">
                    Whether celebrating joy or navigating challenges, share your story and listen to others'.
                  </p>
                </div>

                <div className="feature-item">
                  <div className="feature-header">
                    <h3 className="feature-title">Learn and Grow</h3>
                  </div>
                  <p className="feature-description">
                    Discover new perspectives, gain insights, and expand your understanding through collective wisdom.
                  </p>
                </div>
              </div>
            </div>

            <div className="image-section">
              <img src={Frame244} alt="Community Connection" className="community-image" />
            </div>
          </div>
        </div>
      </React.Fragment>
    </StyledEngineProvider>
  );
};

export default WhyCommunity;
